import { createAction, props } from '@ngrx/store';
import { ListUserDashboardDto, ListUserVisualDto, UserDashboardDto, UserVisualDto } from '../../../services/api.services';
import { AppError } from '../../../shared/utils';
import { createItemSelectorActions } from '../item-selector/actions';
import { InsightsLibraryDashboard, InsightsLibraryDashboardCategory, InsightsLibraryPage, InsightsLibraryVisual, InsightsLibraryVisualCategory } from './types';


export const setVisible = createAction(
  '[InsightsLibrary] Set Visible',
  props<{ visible: boolean }>()
);

export const setPage = createAction(
  '[InsightsLibrary] Set Page',
  props<{ page: InsightsLibraryPage }>()
);

export const setStarredOnly = createAction(
  '[InsightsLibrary] Set StarredOnly',
  props<{ starredOnly: boolean }>()
);

export const setFilter = createAction(
  '[InsightsLibrary] Set Filter',
  props<{ filter: string | null }>()
);

export const toggleViewMode = createAction(
  '[InsightsLibrary] Toggle View Mode',
  props<{ viewMode: boolean }>()
);


//#region Dashboard Actions
export const loadDashboards = createAction(
  '[InsightsLibrary] Load Dashboards'
);

export const loadDashboardsSuccess = createAction(
  '[InsightsLibrary] Load Dashboards Success',
  props<{ dashboards: ListUserDashboardDto[] }>()
);

export const loadDashboardsFailure = createAction(
  '[InsightsLibrary] Load Dashboards Failure',
  props<{ error: AppError }>()
);


export const viewDashboard = createAction(
  '[InsightsLibrary] View Dashboard',
  props<{ item: InsightsLibraryDashboard }>()
);


export const copyDashboard = createAction(
  '[InsightsLibrary] Copy Dashboard',
  props<{ item: InsightsLibraryDashboard }>()
);

export const copyDashboardSuccess = createAction(
  '[InsightsLibrary] Copy Dashboard Success',
  props<{ dashboard: ListUserDashboardDto }>()
);

export const copyDashboardFailure = createAction(
  '[InsightsLibrary] Copy Dashboard Failure',
  props<{ error: AppError }>()
);

export const updateUserDashboard = createAction(
  '[InsightsLibrary] Update User Dashboard',
  props<{ item: InsightsLibraryDashboard, userDashboard: UserDashboardDto }>()
);

export const updateUserDashboardSuccess = createAction(
  '[InsightsLibrary] Update User Dashboard Success',
  props<{ item: InsightsLibraryDashboard, userDashboard: UserDashboardDto }>()
);

export const updateUserDashboardFailure = createAction(
  '[InsightsLibrary] Update User Dashboard Failure',
  props<{ error: AppError }>()
);

export const exportDashboardToPdf = createAction(
  '[InsightsLibrary] Export Dashboard To Pdf',
  props<{ item: InsightsLibraryDashboard }>()
);


export const dashboardItemSelector =
  createItemSelectorActions<InsightsLibraryDashboard, InsightsLibraryDashboardCategory>('Dashboards');
//#endregion

//#region Visual Actions
export const loadVisuals = createAction(
  '[InsightsLibrary] Load Visuals'
);

export const loadVisualsSuccess = createAction(
  '[InsightsLibrary] Load Visuals Success',
  props<{ visuals: ListUserVisualDto[] }>()
);

export const loadVisualsFailure = createAction(
  '[InsightsLibrary] Load Visuals Failure',
  props<{ error: AppError }>()
);

export const viewVisual = createAction(
  '[InsightsLibrary] View Visual',
  props<{ item: InsightsLibraryVisual }>()
);


export const copyVisual = createAction(
  '[InsightsLibrary] Copy Visual',
  props<{ item: InsightsLibraryVisual }>()
);

export const copyVisualSuccess = createAction(
  '[InsightsLibrary] Copy Visual Success',
  props<{ visual: ListUserVisualDto }>()
);

export const copyVisualFailure = createAction(
  '[InsightsLibrary] Copy Visual Failure',
  props<{ error: AppError }>()
);


export const updateUserVisual = createAction(
  '[InsightsLibrary] Update User Visual',
  props<{ item: InsightsLibraryVisual, userVisual: UserVisualDto }>()
);

export const updateUserVisualSuccess = createAction(
  '[InsightsLibrary] Update User Visual Success',
  props<{ item: InsightsLibraryVisual, userVisual: UserVisualDto }>()
);

export const updateUserVisualFailure = createAction(
  '[InsightsLibrary] Update User Visual Failure',
  props<{ error: AppError }>()
);


export const visualItemSelector =
  createItemSelectorActions<InsightsLibraryVisual, InsightsLibraryVisualCategory>('Visuals');
//#endregion

